// extracted by mini-css-extract-plugin
export default {"container":"SearchBar_container__-X-aU","searchInput":"SearchBar_searchInput__SKBdj","clearButton":"SearchBar_clearButton__9jtze"};